<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    :source="source"
    :config="config"
    :filters="filters"
    title="Promo Codes"
    csv-file-name="promo_codes"
    use-datatable-export-csv
    :map-row-class="mapRowClass"
  >
    <template #actions>
      <slot name="actions">
        <a
          href="/discounts/new"
          class="flex overflow-hidden gap-2 justify-center items-center px-5 py-2.5 !rounded-lg border no-underline text-white bg-blue-700 border-blue-700 hover:bg-blue-800"
        >
          <i class="fa fa-plus fa-fw"></i> Add Promo Code
        </a>
      </slot>
    </template>
  </DatatableReportV3>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["showAccountingCategories", "showAccountingClasses"]),
    ...mapState({
      legacyDiscountBatchingEnabled({ tenant }) {
        return tenant?.legacy_discount_batching;
      },
      tenantLoaded({ tenant }) {
        return !!tenant;
      },
      config() {
        return {
          order: [[0, "asc"]],
          responsive: true,
          columns: [
            { data: "code", title: "Code", responsivePriority: 1 },
            { data: "type", title: "Type", responsivePriority: 2 },
            {
              data: "starts_at",
              title: "Starts at",
              searchable: false,
              responsivePriority: 4
            },
            {
              data: "expires_at",
              title: "Expires at",
              searchable: false,
              responsivePriority: 5
            },
            {
              data: "amount",
              title: "Amount",
              searchable: false,
              responsivePriority: 3
            },
            {
              data: "accounting_category",
              title: "Accounting Category",
              filterName: "accounting_category_id",
              searchable: false,
              visible:
                this.legacyDiscountBatchingEnabled &&
                this.showAccountingCategories,
              responsivePriority: 6
            },
            {
              data: "accounting_class",
              title: "Accounting Class",
              filterName: "accounting_class_id",
              searchable: false,
              visible:
                this.legacyDiscountBatchingEnabled &&
                this.showAccountingClasses,
              responsivePriority: 7
            },
            {
              data: "actions",
              title: "Actions",
              orderable: false,
              searchable: false
            }
          ]
        };
      }
    })
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Promo Codes" });
  },
  methods: {
    mapRowClass({ data }) {
      const isArchived = data.archived === true || data.archived === "true";
      return isArchived ? "archived-promo" : "";
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(tr.archived-promo td) {
  text-decoration: line-through;
  color: #6b7280;
}
</style>
